<template>
  <div :class="rootClass">
    <div :class="[`${rootClass}__container`, 'container']">
      <aside :class="`${rootClass}__aside`">
        <VehicleCard
          :model="vehicle_name"
          :image="picture"
          :price="price"
          :specs="[]"
        >
          <template #footer>
            <VehicleCardSection :title="lang.included">
              <ul :class="`${rootClass}__list`">
                <li
                    v-for="(extra, index) in includedExtras"
                    :key="`vehicle-card-section-extra-${index}`"
                >
                    <span><i aria-hidden="true" class="fa fa-check"></i></span>&nbsp;
                    <span>{{extra.name}}</span>
                </li>
              </ul>
            </VehicleCardSection>
            <VehicleCardSection :title="lang.extras">
              <CheckboxField
                v-for="(extra, index) in paidExtras"
                 v-if="!extra.hidden"
                :key="`vehicle-card-section-paid-extra-${index}`"
                :id="'extra' + extra.id"
                :name="'extra' + extra.id"
                :value="extra.id"
                :label=getExtraLabel(extra)
                type="switch"
                @input="onExtraChanged"
              />
              <ul :class="`${rootClass}__list`" v-if="nonSelectableExtraIsApplied">
                <li>
                    <span><i aria-hidden="true" class="fa fa-check"></i></span>&nbsp;
                    <span>{{getExtraLabel(nonSelectableExtras)}}    </span>
                </li>
              </ul>
            </VehicleCardSection>
          </template>
        </VehicleCard>
      </aside>
      <div :class="`${rootClass}__main`">
        <div class="form-card">
          <form :class="`${rootClass}__form`">
            <input type="hidden" v-model="vehicle_id">
            <template v-if="reservedDates">
              <div :class="[`${rootClass}__form-date-time-fields`, `${rootClass}__field`]">
                <datepicker
                  v-model="rent_start"
                  wrapper-class="form-control pull-right"
                  input-class="datepicker-input"
                  style="z-index: 4"
                  :monday-first="mondayFirst"
                  :placeholder=lang.rent_start
                  :disabled-dates="datepicker1.disabled"
                  :highlighted="datepicker1.highlighted"
                  :language= getLocale()
                  @input="onDatepicker1Set"
                />
                <time-selector
                  class="select-form"
                  :hour="rent_start_hour"
                  :from="regularopeningtime"
                  :to="regularclosingtime"
                  :disabledfrom="timepicker1.disabledFrom"
                  :disabledto="timepicker1.to"
                  :extendedto="extendedto"
                  @change="value => {this.rent_start_hour = value}"
                />
              </div>

              <div :class="[`${rootClass}__form-date-time-fields`, `${rootClass}__field`]">
                <datepicker
                  v-model="rent_end"
                  wrapper-class="form-control pull-right"
                  input-class="datepicker-input"
                  style="z-index: 3"
                  :monday-first="mondayFirst"
                  :placeholder=lang.rent_end
                  :disabled-dates="datepicker2.disabled"
                  :highlighted="datepicker2.highlighted"
                  :open-date="datepicker2.opendate"
                  :disabled="datepicker2.isDisabled"
                  :language= getLocale()
                  @input="onDatepicker2Set"
                  ref="datePicker2"
                />
                <time-selector
                  class="select-form"
                  :hour="rent_end_hour"
                  :from="regularopeningtime"
                  :to="regularclosingtime"
                  :disabledfrom="timepicker2.disabledFrom"
                  :disabledto="timepicker2.to"
                  :extendedto="extendedto"
                  @change="value => {this.rent_end_hour = value; calculateRate();}"
                />
              </div>
            </template>
            <template v-else>
                <loader :loading="loading.show" :color="loading.color"></loader>
            </template>

            <TextField
                id="renter_name"
                name="renter_name"
                :value="renter_name"
                :placeholder="lang.name"
                :class="`${rootClass}__field`"
                @input="updateField"
            />

            <TextField
                id="renter_email"
                name="renter_email"
                :value="renter_email"
                :placeholder="lang.email"
                type="email"
                :class="`${rootClass}__field`"
                @input="updateField"
            />

            <TextField
                id="renter_phone"
                name="renter_phone"
                :value="renter_phone"
                :placeholder="lang.phone"
                type="email"
                :class="`${rootClass}__field`"
                @input="updateField"
            />

            <SelectField
                id="pickup_location"
                name="pickup_location"
                :value="pickup_location"
                :placeholder="lang.pickup_location"
                :options="pickupLocationOptions"
                :class="`${rootClass}__field`"
                :text="pickupText"
                @input="updateField"
            />
              <SelectField
                  v-show="dropoffEnabled"
                  id="dropoff_location"
                  name="dropoff_location"
                  :value="dropoff_location"
                  :placeholder="lang.dropoff_location"
                  :options="dropoffLocationOptions"
                  :class="`${rootClass}__field`"
                  @input="updateField"
              />
            <SelectField
                v-show="isBike"
                id="size"
                name="size"
                :value="size"
                :placeholder="lang.select_size"
                :options="sizesOptions"
                :class="`${rootClass}__field`"
                @input="updateField"
            />

              <VoucherField
                  :value="voucher"
                  :placeholder="lang.voucher_code"
                  :class="`${rootClass}__field`"
                  :status="voucher_status"
                  :error-text="lang.voucher_error_text"
                  :ok-text="lang.voucher_ok_text"
                  @input="applyVoucher"
              />

            <CheckboxField
                id="tos"
                name="tos"
                :class="`${rootClass}__field`"
                :value="tos"
                @input="updateField({ ...$event, value: !tos })"
            >
                <template #label>
                    <a :href="'/' + bike.locale + '/page/conditions'">{{ lang.tos }}</a>
                </template>
            </CheckboxField>

            <footer :class="`${rootClass}__form-footer`">
              <ul :class="`${rootClass}__summary`">
                <li :class="`${rootClass}__summary-item`">{{ lang.days }}: <strong>{{calculatedRates.days}}</strong></li>
                <li :class="`${rootClass}__summary-item`">{{ lang.vehicle_rent_price }}: <strong v-if="calculatedRates.list_vehicle_rent_price">{{(parseFloat(calculatedRates.list_vehicle_rent_price)).toFixed(2)}} €</strong></li>
                <li v-if="calculatedRates.discount > 0 " :class="`${rootClass}__summary-item`">{{ lang.discount }}: <strong>{{calculatedRates.discount}} €</strong></li>
                <li v-if="calculatedRates.extras_price > 0" :class="`${rootClass}__summary-item`">{{ lang.extras }}: <strong>{{calculatedRates.extras_price}} €</strong></li>
                <li :class="`${rootClass}__summary-item--separator`"></li>
                <li :class="[`${rootClass}__summary-item`, `${rootClass}__summary-item--highlighted`]">{{ lang.subtotal }}: <strong v-if="calculatedRates.subtotal">{{calculatedRates.subtotal}} €</strong></li>
                <li :class="`${rootClass}__summary-item--separator`"></li>
                <li
                    v-for="(taxes,rate) in calculatedRates.taxes"
                    :key="`summary-taxes-${rate}`"
                    :class="`${rootClass}__summary-item`"
                >{{ lang.taxes.replace(':taxes', Math.round(rate * 1000)/10) }}: <strong>{{taxes}}€</strong></li>
                <li :class="`${rootClass}__summary-item--separator`"></li>
                <li :class="[`${rootClass}__summary-item`, `${rootClass}__summary-item--highlighted`]">{{ lang.total }}: <strong v-if="calculatedRates.total">{{calculatedRates.total}}€</strong></li>
              </ul>
              <div :class="`${rootClass}__form-footer-actions`">
                <div  :class="`${rootClass}__conditions`">
                    <p>{{ lang.conditions }} <a :href="'/' + bike.locale + '/page/privacy'">{{ lang.privacy }}</a></p>
                </div>
                <button type="button" :class="[`${rootClass}__form-action`, 'btn btn-light btn-lg']" :disabled="disabled" @click="submit">{{ lang.submit }}</button>
              </div>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleCard from './vehicle-card/VehicleCard.vue'
import VehicleCardSection from './vehicle-card/VehicleCardSection.vue'
import TextField from './TextField.vue'
import VoucherField from './VoucherField.vue'
import SelectField from './SelectField.vue'
import CheckboxField from './CheckboxField.vue'
    import Datepicker from 'vuejs-datepicker'
    import TimeSelector from './TimeSelector'
    import Loader from 'vue-spinner/src/PulseLoader.vue'
    import {en, es, de} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
    export default {
        components: {
            VehicleCard,
            VehicleCardSection,
            TextField,
            VoucherField,
            SelectField,
            CheckboxField,
            Datepicker,
            Loader,
            TimeSelector
        },
        props: {
            vehicle: {
                required: true,
                type: Object
            },
            priceperday: {
                required: true,
                type: String
            },
            lang: {
                required: true,
                type: Object
            },
            schedule_sunday_end: {
                required: true,
                type: Number
            },
            locations: {
                required: true,
                type: Object
            },
            dropoff: {
                required: true,
                type: Boolean,
                default: false
            },
            after_hours_location_binding: {
                type: [Object, String],
                required: true,
                default: () => ({})
            },
            blockpastreservation: {
                required: true,
                type: Boolean,
                default: false
            },
            voucher:{
                required: false,
                type: String,
            },
            minreservationdays: {
                required: true,
                type: Number
            },
            preventnextmorningreservations: {
                required: true,
                type: Boolean,
                default: false
            },
            regularopeningtime: {
                required: false,
                type: Number,
                default: 9
            },
            regularclosingtime: {
                required: false,
                type: Number,
                default: 18
            },
            extendedto: {
                required: false,
                type: Number,
                default: false
            },
            tenant: {
                required: true,
                type: String,
                default: '',
            }
        },
        data() {
            return {
                rootClass: 'checkout-page',
                vehicle_name: this.vehicle['name'],
                price: this.priceperday,
                picture: this.vehicle['attachments'][0]['url'],
                vehicle_id: this.vehicle['id'],
                vehicle_type: this.vehicle['type'],
                vehicle_amount: this.vehicle['amount'],
                pickup_options: this.vehicle['pickup_options'],
                extras_list: Object.keys(this.vehicle['extras']).map((key) => ({ ...this.vehicle['extras'][key], name: key })),
                extras: [],
                bike: bike,
                reservedDates: null,
                holidays: null,
                renter_name: '',
                renter_email: '',
                renter_phone: '',
                rent_start: '',
                rent_start_hour: this.regularopeningtime,
                rent_end: '',
                rent_end_hour: this.regularopeningtime,
                size: '',
                pickupText: '',
                voucher_status:'none',
                pickup_location: '',
                dropoff_location: '',
                tos: false,
                disabled: true,
                mondayFirst:true,
                calculatedRates: {},
                loading:{
                    show: true,
                    color: '#194482',
                },
                datepicker1: {
                    disabled:{
                        to: this.getDateOf(new Date()),
                        customPredictor: this.isDayDisabled
                    },
                    highlighted: {
                        from:'',
                        to: '',
                    }
                },
                datepicker2: {
                    isDisabled: true,
                    disabled:{
                        from: '',
                        to: this.getDateOf(new Date()),
                        customPredictor: this.isDayDisabled,
                    },
                    highlighted: {
                        from:'',
                        to: '',
                    },
                    opendate: this.getDateOf(new Date())
                },
                timepicker1:{
                    disabledFrom: this.regularopeningtime,
                    to: this.extendedto || this.regularclosingtime
                },
                timepicker2:{
                    disabledFrom: this.regularopeningtime,
                    to: this.extendedto || this.regularclosingtime
                },
                sizes: ['XS', 'S', 'M', 'L', 'XL'],
                locales: {
                  en: en,
                  es: es,
                  de: de
                },
                nonSelectableExtraIsApplied: false,
            }
        } ,
        computed: {
            includedExtras () {
                return this.extras_list.filter(({ price }) => price['amount'] === "0")
            },
            paidExtras () {
                return this.extras_list.filter(({ price, id }) => {
                    if (this.afterHoursBinding && parseInt(id) === parseInt(this.afterHoursBinding.extraId)) {
                        return false;
                    }
                    return price['amount'] !== "0";
                });
            },
            nonSelectableExtras () {
                let value = this.extras_list.find(({ id }) =>
                    this.afterHoursBinding &&
                    parseInt(id) === parseInt(this.afterHoursBinding.extraId)
                );
                return value;
            },
            pickupLocationOptions () {
                const isAfterHours = this.rent_start_hour > this.regularclosingtime;
                const afterHoursLocationId = this.afterHoursBinding?.locationId;

                return Object.keys(this.locations).map((location) => ({
                    value: location,
                    label: this.locations[location],
                    disabled: isAfterHours && this.afterHoursBinding ?
                        location !== afterHoursLocationId :
                        this.isLocationDisabled(location)
                }));
            },

            dropoffLocationOptions () {
                return Object.keys(this.locations).map((location) => {
                    return {
                        value: location,
                        label: this.locations[location],
                        disabled: this.isLocationDisabled(location)
                    }
                })
            },

            sizesOptions () {
                return this.sizes.map((size) => {
                    return {
                        value: size,
                        label: size
                    }
                })
            },
            isBike() {
                return this.vehicle_type === "bike"
            },
            dropoffEnabled() {
                return this.dropoff
            },
            afterHoursBinding() {
                if (typeof this.after_hours_location_binding === 'string') {
                    try {
                        return JSON.parse(this.after_hours_location_binding);
                    } catch (e) {
                        return {};
                    }
                }
                return this.after_hours_location_binding;
            },
        },
        methods:
        {
            getExtraLabel(extra){
                let priceText = extra.name + " - " + extra.price['formatted'];
                if(!extra.single_charge){
                    priceText += this.lang.eurosperday;
                }

                if(extra.max_charge.amount > 0){
                    priceText +=  ", Max. " + extra.max_charge['formatted']
                }
                return priceText;
            },
            onExtraChanged({ value, selected }){
                if(selected){
                    this.extras.push(value);
                }else{
                    this.extras.splice(this.extras.indexOf(value), 1);
                }

                this.calculateRate();
            },

            isDayDisabled(date){
                let isTooLate = moment().isSame(date, 'day')  && moment().hour() > this.regularclosingtime-1;
                return this.isDayBlocked(date) || this.isHoliday(date) || isTooLate ;
            },
            isDayBlocked(date){
                let startOfTheDay = moment(date).hours(this.regularopeningtime).minute(0).second(1);
                let endOfTheDay = moment(date).hours(this.regularclosingtime).minute(0).second(0);
                for (let reserved of this.reservedDates){
                  if( moment(reserved.start).isBefore(startOfTheDay) && moment(reserved.end).isAfter(endOfTheDay)) {
                      return true;
                  }
                }
                return false;
            },
            isHoliday(date){
                return this.holidays.includes(moment(date).format('YYYY-MM-DD'))
            },

            getEndOfTheDay(date) {
                if(this.tenant === 'jaira'){
                    return this.extendedto;
                }

                if (moment(date).day() === 0) {
                    return this.schedule_sunday_end;
                }
                return this.regularclosingtime;
            },

            checkIfStartIsInThePast(date, from){
                if( this.blockpastreservation && moment().isSame(date, 'day')){
                    if(from < moment().hour() + 2){
                        from =  moment().hour() + 2;
                    }
                }
                return from;
            },

            getEarliestHour(date){
                let dayStart = moment(this.rent_start).hours(this.regularopeningtime).minute(0).second(0);
                //don't accept next morning reservations after 6pm
                if(this.preventnextmorningreservations && moment().diff(dayStart,'hours') > -16){
                    return 10;
                }
                return this.regularopeningtime;
            },

            getEarliestAllowedEndDate(date){
                return this.minreservationdays > 0 ?
                        moment(date).add(this.minreservationdays, 'days').toDate() :
                        date;
            },

            getTimeConstraints(date) {
                let from = this.getEarliestHour(date);
                let to = this.getEndOfTheDay(date);

                // Check reservations for this date
                for (let reserved of this.reservedDates) {
                    if (moment(reserved.end).isSame(date, 'day')) {
                        let hour = moment(reserved.end).format('HH');
                        from = hour > from ? hour : from;
                        if (parseInt(moment(reserved.end).format('mm')) == 30) {
                            from++;
                        }
                    } else if (moment(reserved.start).isSame(date, 'day')) {
                        let hour = moment(reserved.start).format('HH');
                        to = hour < to ? hour : to;
                    }
                }

                // Check if start time is in the past
                from = this.checkIfStartIsInThePast(date, from);
                return { from, to };
            },

            onDatepicker1Set(date) {
                const { from, to } = this.getTimeConstraints(date);
                this.timepicker1.disabledFrom = from;
                this.timepicker1.to = to;
                this.rent_start_hour = from;

                let earliestAllowedEndDate = this.getEarliestAllowedEndDate(date);

                // Reset end date fields
                this.rent_end = '';
                this.rent_end_hour = this.regularopeningtime;

                // Update highlights and disabled states
                this.updateDatepickerStates(date, earliestAllowedEndDate);

                this.calculatedRates = {};
            },

            updateDatepickerStates(startDate, earliestAllowedEndDate) {
                this.datepicker1.highlighted.from = this.getDateOf(startDate);
                this.datepicker1.highlighted.to = '';

                this.datepicker2.isDisabled = false;
                this.datepicker2.from = this.regularopeningtime;
                this.datepicker2.opendate = this.getDateOf(startDate);
                this.datepicker2.highlighted.from = this.getDateOf(earliestAllowedEndDate);
                this.datepicker2.highlighted.to = '';

                this.$nextTick(() => {
                    this.datepicker2.disabled.to = this.getDateOf(earliestAllowedEndDate);
                    let from = this.getFirstDisabledDateAfterStart();
                    if (from) {
                        let hour = from.toDate().getHours();
                        if (hour < this.regularopeningtime) {
                            from.subtract(1, 'd');
                        }
                        this.datepicker2.disabled.from = this.getDateOf(from.toDate());
                    } else {
                        this.datepicker2.disabled.from = null;
                    }
                });
            },

            getFirstDisabledDateAfterStart(){
                for (let blocked of this.reservedDates){
                    let rentStart = moment(this.rent_start).hours(this.rent_start_hour).minute(0).second(0);
                    if( moment(blocked.start).isAfter(rentStart)) {
                        return moment(blocked.start);
                    }
                }
                return '';
            },

            onDatepicker2Set(date){
                let nextBlocker = moment(this.getFirstDisabledDateAfterStart());
                this.timepicker2.to = nextBlocker.isValid() && nextBlocker.isSame(date, 'day') ? parseInt(nextBlocker.hours()) : this.getEndOfTheDay(this.rent_end);
                this.rent_end_hour = this.timepicker2.to < this.rent_end_hour ? this.regularopeningtime : this.rent_end_hour;
                this.datepicker1.highlighted.to = this.getDateOf(this.rent_end);
                this.datepicker2.highlighted.to = this.getDateOf(this.rent_end);
                this.calculateRate();
            },

            applyVoucher: function(value){
                this.updateField({ name: 'voucher', value: value })
                if (this.timeout)
                    clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.calculateRate();
                }, 800);
            },

            updateField({ name, value }) {
                this[name] = value
                this.evalSubmitState()
                //JairaCustomLogic for pickups
                if(this.tenant === 'jaira' && this.rent_start_hour === 9 && this.pickup_location == 6){
                    this.pickupText = this.lang.earliestPickupTime
                }else{
                    this.pickupText = ''
                }
            },

            evalSubmitState() {
                let testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
                let cond1 = this.renter_name === "" || this.renter_email === "" || this.renter_phone === ""
                    || this.rent_start === "" || this.rent_end === "" || !this.rent_start_hour
                    || !this.rent_end_hour || !this.tos || this.pickup_location ===""

                let cond2 = !testEmail.test(this.renter_email) || !Date.parse(this.rent_start) || !Date.parse(this.rent_end)
                let cond3 = this.isBike && this.size === ""
                let cond4 = this.dropoffEnabled && this.dropoff_location ===""
                this.disabled = cond1 || cond2 || cond3 || cond4;
            },

            async calculateRate() {
                if (!this.rent_start || !this.rent_end || !this.rent_start_hour || !this.rent_end_hour) {
                    return;
                }

                try {
                    const queryParams = new URLSearchParams({
                        vehicle_id: parseInt(this.vehicle_id),
                        rent_start: window.moment(this.rent_start).format('DD/MM/YYYY'),
                        rent_start_hour: `${parseInt(this.rent_start_hour) === 24 ? 23 : parseInt(this.rent_start_hour)}:00`,
                        rent_end: window.moment(this.rent_end).format('DD/MM/YYYY'),
                        rent_end_hour: `${parseInt(this.rent_end_hour) === 24 ? 23 : parseInt(this.rent_end_hour)}:00`,
                        voucher_code: this.voucher,
                        ...this.getExtrasParams()
                    }).toString();

                    const response = await axios.get(`/calculate?${queryParams}`);
                    this.calculatedRates = response.data;
                    this.voucher_status = this.calculatedRates.voucher_status;
                } catch (error) {
                    console.error('Failed to calculate rates:', error);
                    // Handle error appropriately
                }
            },

            getExtrasParams() {
                return this.extras.reduce((params, element) => {
                    params[`extras[${element}]`] = 1;
                    return params;
                }, {});
            },

            submit(){
                let payload = {
                    renter_name: this.renter_name,
                    renter_email: this.renter_email,
                    renter_phone: this.renter_phone,
                    voucher_code: this.voucher,
                    tos: Boolean(this.tos),
                    vehicle_id: parseInt(this.vehicle_id),
                    vehicle_size: this.size,
                    extras : [],
                    rent_start: window.moment(this.rent_start).format('DD/MM/YYYY'),
                    rent_start_hour: parseInt(this.rent_start_hour) + ':00',
                    rent_end: window.moment(this.rent_end).format('DD/MM/YYYY'),
                    rent_end_hour: parseInt(this.rent_end_hour) + ':00',
                    pickup_location: this.pickup_location,
                    dropoff_location: this.dropoff_location
                }
                this.extras.forEach(element => {
                    payload.extras[element]= 1;
                });
                axios.post('/' + bike.locale + '/reservation', payload)
                        .then(response => window.location.href = response.data);
            },

            getLocale(){
              return this.locales[this.bike.locale];
            },

            getDateOf(date){
              return new Date(date.getFullYear(), date.getMonth(), date.getDate())
            },
            isLocationDisabled(location){
                if (this.pickup_options.includes('todos') || this.pickup_options.includes(location)) return false;
                return true;
            }
        },
        watch: {
            rent_start_hour(newHour) {
                const isAfterHours = newHour > this.regularclosingtime;
                if (isAfterHours && this.afterHoursBinding) {
                    // Set location
                    this.pickup_location = this.afterHoursBinding.locationId;

                    // Add extra if not already included
                    if (!this.extras.includes(this.afterHoursBinding.extraId)) {
                        this.extras.push(this.afterHoursBinding.extraId);
                        this.nonSelectableExtraIsApplied = true;

                    }
                } else {
                    // Remove extra if exists when switching back to regular hours
                    const extraIndex = this.extras.indexOf(this.afterHoursBinding?.extraId);
                    if (extraIndex > -1) {
                        this.extras.splice(extraIndex, 1);
                        this.nonSelectableExtraIsApplied = false;
                    }
                }
                this.calculateRate();
            }
        },
        mounted:function () {
          this.$nextTick(function () {
              let urlParams = new URLSearchParams(window.location.search);
              if (urlParams.get('start')) {
                const start = moment(urlParams.get('start'),'YYYY-MM-DD H:00:00')
                this.rent_start = start.toDate();
                this.rent_start_hour = start.format('H');
                let originalStartHour = this.rent_start_hour;
                let earlierHour = this.getEarliestHour(this.rent_start);
                if(earlierHour > this.rent_start_hour){
                    this.rent_start_hour = earlierHour;
                }
                let start_hour = this.rent_start_hour
                this.rent_start_hour = this.checkIfStartIsInThePast(start, start_hour);
                if(originalStartHour !== this.rent_start_hour ){
                    this.timepicker1.disabledFrom = this.rent_start_hour;
                }
                this.timepicker1.to = this.getEndOfTheDay(this.rent_start);
              }
              if (urlParams.get('end')) {
                const end = moment(urlParams.get('end'),'YYYY-MM-DD H:00:00')
                this.rent_end = end.toDate();
                this.rent_end_hour = end.format('H');
              }
            axios.get("/availability/calendar/" +  parseInt(this.vehicle_id))
                .then(response => {
                  this.reservedDates = response.data.blockedDays;
                  this.holidays = response.data.holidays;
                  this.calculateRate()
                });
          });

        }
    }
</script>

<style>
.checkout-page__form-date-time-fields .datepicker-input, .checkout-page__form-date-time-fields .select-form {
  background: transparent;
  border: none;
  box-shadow: none;
}
.checkout-page__form-date-time-fields .datepicker-input {
  width: 100%;;
}
.checkout-page__form-date-time-fields .datepicker-input::placeholder {
  color: black;
}
.checkout-page__form-date-time-fields .select-form {
  font-size: 0.875rem;
  line-height: 1.2;
}
.checkout-page__form-date-time-fields .datepicker-input:focus, .checkout-page__form-date-time-fields .select-form:focus {
  outline: 0;
}
</style>
